!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={279:(e,t,o)=>{o.d(t,{BreadcrumbsBase:()=>n});const r=require("styled-components"),n=o.n(r)().nav.attrs({className:"breadcrumbs"})`
  display: inline-flex;
  align-items: center;

  & > button {
    margin: 0 16px;

    cursor: pointer;

    &:focus {
      outline: var(--outline);
      outline-offset: 4px;
    }

    &:focus:not(:focus-visible) {
      outline: none;
      outline-offset: none;
    }
  }

  &:focus:not(:focus-visible) {
    outline: 0;
  }

  &:focus-visible {
    color: var(--color-primary-variant);
    outline: var(--outline);
    outline-offset: 4px;
    & > i {
      color: var(--color-primary-variant);
    }
  }

  &:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }

  & > a,
  & > button {
    display: flex;
    align-items: center;
    position: relative;
    line-height: 24px;

    padding: 16px 0;

    border: none;
    box-sizing: border-box;
    background: transparent;

    text-decoration: none;
    color: var(--color-on-background);

    > span {
      text-decoration: underline;
    }
  }

  & > a:not(:hover, :focus, :focus-visible, :active) {
    color: var(--color-inactive);
  }

  & > a + a {
    margin-left: 16px;
  }

  & i {
    color: var(--color-primary);
    margin-left: 16px;
  }
`}},t={};function o(r){var n=t[r];if(void 0!==n)return n.exports;var i=t[r]={exports:{}};return e[r](i,i.exports,o),i.exports}o.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return o.d(t,{a:t}),t},o.d=(e,t)=>{for(var r in t)o.o(t,r)&&!o.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};return(()=>{o.r(r),o.d(r,{default:()=>c});const e=require("react");var t=o.n(e);const n=require("@storeblocks/icon");var i=o(279);const l=3;function a(o){return(0,e.cloneElement)(o,Object.assign(Object.assign({},o.props),{children:t().createElement(t().Fragment,null,t().createElement("span",null,o.props.children),t().createElement(n.SystemIcon,{name:"chevron-right",size:16}))}))}const c=function(o){var{children:r,collapseLimit:c=l}=o,s=function(e,t){var o={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(r=Object.getOwnPropertySymbols(e);n<r.length;n++)t.indexOf(r[n])<0&&Object.prototype.propertyIsEnumerable.call(e,r[n])&&(o[r[n]]=e[r[n]])}return o}(o,["children","collapseLimit"]);if(c<2)throw new Error("collapseLimit cannot be less then 2. Please set collapseLimit to at least 2");const u=e.Children.count(r)<=c,[p,f]=(0,e.useState)(u);(0,e.useEffect)((()=>{f(u)}),[u]);const b=(0,e.useCallback)((()=>{const o=e.Children.map(r,a);if(p)return o;const i=o[0],l=o.slice(-1);return t().createElement(t().Fragment,null,i,t().createElement("button",{type:"button",onClick:()=>f(!0)},t().createElement("span",{"aria-label":"expand"},"..."),t().createElement(n.SystemIcon,{name:"chevron-right",size:16})),l)}),[p,r]);return t().createElement(i.BreadcrumbsBase,Object.assign({},s),b())}})(),r})()));
//# sourceMappingURL=index.js.map